import FullEpgPersistance from './FullEpgPersistance';

export default FullEpgPersistance;



// WEBPACK FOOTER //
// ./src/components/FullEpgPersistance/index.js